/* Washington Diamond — header
   Mega-dropdown open/close on hover, focus and keyboard; mobile menu overlay
   with focus trap, Escape-to-close, and body scroll lock. */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var CLOSE_DELAY = 180; // ms of grace to cross from the nav link into the panel

  function trap(container, e) {
    var nodes = Array.prototype.slice
      .call(container.querySelectorAll(FOCUSABLE))
      .filter(function (n) {
        return n.offsetParent !== null;
      });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function init(root) {
    if (!root || root.dataset.wdHeaderReady === 'true') return;
    root.dataset.wdHeaderReady = 'true';

    /* ---- Mega dropdowns ---- */
    var openKey = null;
    var closeTimer = null;

    function setOpen(key) {
      openKey = key;
      root.querySelectorAll('[data-wd-panel]').forEach(function (panel) {
        var on = panel.dataset.wdPanel === key;
        panel.hidden = !on;
      });
      root.querySelectorAll('[data-wd-panel-trigger]').forEach(function (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          trigger.dataset.wdPanelTrigger === key ? 'true' : 'false'
        );
      });
    }

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(function () {
        closeTimer = null;
        setOpen(null);
      }, CLOSE_DELAY);
    }

    root.querySelectorAll('[data-wd-panel-trigger]').forEach(function (trigger) {
      var key = trigger.dataset.wdPanelTrigger;
      trigger.addEventListener('mouseenter', function () {
        cancelClose();
        setOpen(key);
      });
      trigger.addEventListener('focus', function () {
        cancelClose();
        setOpen(key);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          cancelClose();
          setOpen(key);
          var panel = root.querySelector('[data-wd-panel="' + key + '"]');
          var firstLink = panel && panel.querySelector(FOCUSABLE);
          if (firstLink) firstLink.focus();
        }
      });
    });

    root.querySelectorAll('[data-wd-panel-close]').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        cancelClose();
        setOpen(null);
      });
    });

    // Entering a panel keeps it open; leaving the nav or the panel closes it
    // after a short grace period, so the cursor can cross the gap between them.
    root.querySelectorAll('[data-wd-panel]').forEach(function (el) {
      el.addEventListener('mouseenter', cancelClose);
    });

    root.querySelectorAll('[data-wd-panel], [data-wd-nav]').forEach(function (el) {
      el.addEventListener('mouseleave', scheduleClose);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openKey) {
        var trigger = root.querySelector('[data-wd-panel-trigger="' + openKey + '"]');
        cancelClose();
        setOpen(null);
        if (trigger) trigger.focus();
      }
    });

    root.addEventListener('focusout', function (e) {
      if (openKey && !root.contains(e.relatedTarget)) {
        cancelClose();
        setOpen(null);
      }
    });

    /* ---- Mobile menu ---- */
    var burger = root.querySelector('[data-wd-burger]');
    var overlay = document.querySelector('[data-wd-mobile-menu]');
    var lastFocus = null;

    function openMenu() {
      if (!overlay) return;
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var first = overlay.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function closeMenu() {
      if (!overlay) return;
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (burger) {
      burger.addEventListener('click', function () {
        if (overlay && overlay.hidden) openMenu();
        else closeMenu();
      });
    }

    if (overlay) {
      overlay.querySelectorAll('[data-wd-menu-close]').forEach(function (el) {
        el.addEventListener('click', closeMenu);
      });
      // Any in-page anchor closes the overlay so the jump is visible.
      overlay.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
      overlay.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
        if (e.key === 'Tab') trap(overlay, e);
      });
    }

    setOpen(null);
  }

  function initAll() {
    document.querySelectorAll('[data-wd-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-wd-header]');
    if (root) init(root);
  });
})();